import { History } from '../../helpers/History';
import PropTypes from 'prop-types';
import React from 'react';
import Swal from 'sweetalert2';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { fetchAnalysis } from '../state/actions/AnalysisActions';

export class RequestAnalysisAssignment extends React.PureComponent {
    static propTypes = {
        fetchAnalysis: PropTypes.func.isRequired,
        analysis: PropTypes.object,
        history: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = { goToAnalysisDisabled: false };
    }

    catch = error => {
        Swal({
            title: 'Oops...',
            text: error,
            type: 'error',
        });
    };

    noAnalysisAvailable = () => {
        Swal({ title: 'No analysis available for review at this time.' });
    };

    goToAnalysis = () => {
        const { fetchAnalysis } = this.props;

        this.setState({ goToAnalysisDisabled: true });

        fetchAnalysis()
            .then(payload => {
                const { value: analysis = null } = payload;
                if (!analysis) {
                    return this.noAnalysisAvailable();
                }

                History.push(`/analysis/${analysis.analysisId}`);
            })
            .catch(this.catch);
    };

    render() {
        return (
            <button
                type="button"
                disabled={this.state.goToAnalysisDisabled}
                className="request-analysis btn btn-link"
                onClick={this.goToAnalysis}
            >
                Go to Analysis
            </button>
        );
    }
}

const mapStateToProps = state => state.analysis;

const mapDispatchToProps = dispatch => bindActionCreators({ fetchAnalysis }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(RequestAnalysisAssignment);
